module.exports = __webpack_public_path__ + "static/media/flood2.62a788a6.png";